import { Row, Typography } from "antd";

const PyJupyterlab = ({ appName, app, getData }) => {
    return (
        <>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text></Typography.Text>
            </Row>
        </>
    );
};

export { PyJupyterlab };
